import Vue from 'vue';
import store from './stores/store.js';
import Router from 'vue-router';
import Dashboard from './components/Dashboard.vue';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: () => import('./pages/Login.vue')
        },
        {
            path: '/signout',
            name: 'logout',
            component: () =>  import('./pages/Logout.vue')
        },
        {
            path: '/unauthorised',
            name: 'unauthorised',
            component: () => import('./pages/Unauthorised.vue')
        },
        {
            path: '/',
            name: 'dashboard',
            component: Dashboard,
            // beforeEnter(to, from, next) {
            //     console.log(store.getters.user.data)
            //     if (store.getters.user.data.role.permissionLevel >= 8) {
            //         next();
            //     } else {
            //         next('/sites/' + store.getters.user.data.client.key);
            //     }
            // }
        },
        {
            path: '/landing',
            name: 'landing',
            component: () => import('./pages/Landing.vue')
        },
        {
            path: '/cookie-policy',
            name: 'cookie-policy',
            component: () => import('./pages/CookiePolicy.vue')
        },
        {
            path: '/privacy-policy',
            name: 'privacy-policy',
            component: () => import('./pages/PrivacyPolicy.vue')
        },
        {
            path: '/users',
            name: 'users',
            component: () => import('./pages/Users.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/clients',
            name: 'clients',
            component: () => import('./pages/Clients.vue'),
            meta: { requiresAuth: true },
            beforeEnter(to, from, next) {
                if (store.getters.user.data.role.permissionLevel >= 10) {
                    next();
                } else {
                    next('/unauthorised');
                }
            }
        },
        {
            path: '/sites/:id',
            name: 'sites',
            component: () => import('./pages/Sites.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/asset-bin/:client_id',
            name: 'asset-bin',
            component: () => import('./pages/AssetBin.vue'),
            meta: { requiresAuth: true },
            beforeEnter(to, from, next) {
                if (store.getters.user.data.role.permissionLevel >= 10) {
                    next();
                } else {
                    next('/unauthorised');
                }
            }
        },
        {
            path: '/site-bin/:client_id',
            name: 'site-bin',
            component: () => import('./pages/SiteBin.vue'),
            meta: { requiresAuth: true },
            beforeEnter(to, from, next) {
                if (store.getters.user.data.role.permissionLevel >= 10) {
                    next();
                } else {
                    next('/unauthorised');
                }
            }
        },
        {
            path: '/report-bin/:client_id',
            name: 'report-bin',
            component: () => import('./pages/ReportBin.vue'),
            meta: { requiresAuth: true },
            beforeEnter(to, from, next) {
                if (store.getters.user.data.role.permissionLevel >= 10) {
                    next();
                } else {
                    next('/unauthorised');
                }
            }
        },
        {
            path: '/site/:client_id/:id',
            name: 'site',
            component: () => import('./pages/Site.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/documents/:client_id/:id',
            name: 'documents',
            component: () => import('./pages/SiteDocuments.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/asset-documents/:client_id/:id/:asset_id',
            name: 'asset-documents',
            component: () => import('./pages/AssetDocuments.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/asset-certificates/:client_id/:id/:asset_id',
            name: 'asset-certificates',
            component: () => import('./pages/AssetCertificates.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/asset-notes/:client_id/:id/:asset_id',
            name: 'asset-notes',
            component: () => import('./pages/AssetNotes.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/certificates/:client_id/:id/:asset_id?',
            name: 'certificates',
            component: () => import('./pages/SiteCertificates.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/notes/:client_id/:id/:asset_id?',
            name: 'notes',
            component: () => import('./pages/SiteNotes.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/asset-fault-log/:client_id/:id/:asset_id',
            name: 'asset-fault-log',
            component: () => import('./pages/AssetFaultLog.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/asset-activity-log/:client_id/:id/:asset_id',
            name: 'asset-activity-log',
            component: () => import('./pages/AssetActivityLog.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/site-activity-log/:client_id/:id',
            name: 'site-activity-log',
            component: () => import('./pages/SiteActivityLog.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/assets/:client_id/:id',
            name: 'assets',
            component: () => import('./pages/Assets.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/asset/:client_id/:site_id/:id/:template_id?',
            name: 'asset',
            component: () => import('./pages/Asset.vue'),
            meta: { requiresAuth: true }
        },
        // {
        //     path: '/templates',
        //     name: 'templates',
        //     component: () => import('./pages/Templates.vue'),
        //     meta: { requiresAuth: true }
        // },
        {
            path: '/scan',
            name: 'scan',
            component: () => import('./pages/Scan.vue'),
            meta: { requiresAuth: false }
        },
        {
            path: '/template/:id',
            name: 'template',
            component: () => import('./pages/Template.vue'),
            meta: { requiresAuth: true }
        },
        // {
        //     path: '/scan',
        //     name: 'scan',
        //     component: () => import('./pages/Scan.vue'),
        //     meta: { requiresAuth: false }
        // },
        {
            path: '/settings/:client_id',
            name: 'settings',
            component: () => import('./pages/Settings.vue'),
            meta: { requiresAuth: true },
            beforeEnter(to, from, next) {
                if (store.getters.user.data.role.permissionLevel >= 8) {
                    next();
                } else {
                    next('/unauthorised');
                }
            }
        },
        // {
        //     path: '/importer/:client_id',
        //     name: 'importer',
        //     component: () => import('./pages/Importer.vue'),
        //     meta: { requiresAuth: true }
        // },
        {
            path: '/check-in-out/:client_id/:id/:asset_id?',
            name: 'checkinout',
            component: () => import('./pages/checkInOut.vue')
        },
        {
            path: '/check-success/:checked/:full_name/:company',
            name: 'checksuccess',
            component: () => import('./pages/checkInOutSuccess.vue')
        },
        {
            path: '/fault-log/:client_id/:id/:asset_id',
            name: 'fault-log',
            component: () => import('./pages/FaultLog.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/custom-reports/:client_id',
            name: 'custom-reports',
            component: () => import('./pages/CustomReports.vue'),
            meta: { requiresAuth: true },
            beforeEnter(to, from, next) {
                if (store.getters.user.data.role.permissionLevel >= 8) {
                    next();
                } else {
                    next('/unauthorised');
                }
            }
        },
    ],
    scrollBehavior() {
        return { x: 0, y: 0 };
    }
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {

        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!store.getters.user.loggedIn) {
            next({
                path: '/login',
                query: { redirect: to.name }
            })
        } else {
            next()
        }
    } else {
        /* eslint-disable no-console */
        // console.log(store.getters.user.loggedIn && to.name == 'login')
        /* eslint-enable no-console */
        if (store.getters.user.loggedIn && to.name == 'login') {
            next({
                name: 'dashboard'
            })
        } else {
            next() // make sure to always call next()!
        }

        if (!store.getters.user.loggedIn && to.name == 'dashboard') {
            next({
                path: '/login',
                query: { redirect: to.name }
            })
        }
    }
})

export default router 